<section class="key-xml-gen">
  @if (showAccessDenied) {

    <div class="key-xml-gen__placeholder">
      <i class="fa fa-lock"></i>
      <p>You do not have ADMIN access to view the Key XML Gen screen.</p>
    </div>
  
} @else {

    @if (noSubmission) {

      <div class="key-xml-gen__placeholder">
        <p>Select a submission from the Submissions list to load this grid.</p>
      </div>
    
} @else {

      <!--
        gizmoGrid mount. The legacy template rendered the entire `.gg-table`
        skeleton inline (key-xml-gen.html L144-L318); here the `efileGrid`
        directive owns that DOM and forwards row clicks/ctrlFn callbacks to
        `onGridCallback`. The directive also handles caching keyed by
        `efile/key-xml-gen/<submission_id>` (mirrors legacy
        `EFILE_SCRUBBING_<id>` workspace cache).
      -->
      @if (gridConfig) {
<div
       
        efileGrid
        #keyXmlGrid="efileGrid"
        class="gizmo-grid"
        [gridConfig]="gridConfig"
        (gridCallback)="onGridCallback($event)"
      ></div>
}
    
}

    
  
}

  
</section>

<!--
  Confirm dialog — port of the legacy `app/templates/modals/confirm-action.html`
  invocation in EfileKeyXmlGenController#openConfirmation (L4895-L4907). Now
  rendered through the shared <gtw-confirmation-modal> for visual parity with
  the rest of the efile screens (scrubbing, return-review, etc.).
-->
@if (showConfirm) {
<gtw-confirmation-modal
 
  [config]="confirmModalConfig"
  [visible]="false"
  (confirmed)="onConfirm()"
  (cancelled)="onCancelConfirm()"
  (closed)="onCancelConfirm()"
></gtw-confirmation-modal>
}
